import { useState } from 'react'
import { formatDate } from '../../api'

// Bandeau de contexte d'un evenement — PRESENT SUR TOUS LES ONGLETS (S65).
// Avant, lieu / date / horaires / itineraire vivaient dans le seul onglet
// « Infos » : l'information la plus demandee (« je vais ou, a quelle heure ? »)
// etait la plus cachee, et rien a l'ecran ne disait sur quel marche on etait
// (retour Daniel). Le bandeau remonte ce contexte sous l'en-tete et remplace
// l'onglet Infos, qui disparait.
//
// Repliable : deplie par defaut, l'utilisateur peut le reduire a une ligne pour
// rendre la place au contenu de l'onglet. Style `glass-dark` (bloc vert sombre,
// halo orange) — DESIGN-GUIDE §387 ; le texte y reste creme dans les deux
// themes, donc AUCUN `text-ink` ici.
//
// `boxShadow: 'none'` : l'ombre portee vient de `.glass-dark`, partagee par
// toutes les cartes sombres du portail. On la neutralise ICI (bandeau a plat,
// demande de Daniel) plutot que dans index.css, qui les toucherait toutes.

const ORANGE = 'rgb(var(--c-primary))'
const VERT = 'rgb(var(--c-green))'
const CREME_DOUX = 'rgba(247,240,234,0.75)'

export default function BandeauEvenement({ marche, nbStands, nbProduits }) {
  const [replie, setReplie] = useState(false)
  if (!marche) return null

  const icone = marche.typeConfig?.icone || '🎪'
  const titre = marche.nom || marche.lieu || 'Évènement'
  const horaires = marche.heureDebut && marche.heureFin ? `${marche.heureDebut} – ${marche.heureFin}` : null

  return (
    <div
      className="glass-dark rounded-[20px] px-4 py-3 mb-3 relative overflow-hidden animate-fade-up"
      style={{ boxShadow: 'none' }}
    >
      <div
        className="absolute -top-10 -right-8 w-32 h-32 rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(244,137,83,0.35), transparent 70%)' }}
      />

      <div className="flex items-center gap-2.5 relative">
        <span className="text-[26px] flex-shrink-0">{icone}</span>
        <div className="flex-1 min-w-0">
          <p className="font-serif text-[17px] truncate leading-tight">{titre}</p>
          <p className="text-[11px] mt-0.5 truncate" style={{ color: CREME_DOUX }}>
            {formatDate(marche.date)}
            {horaires && ` · ${horaires}`}
          </p>
        </div>
        <button
          onClick={() => setReplie((v) => !v)}
          aria-expanded={!replie}
          aria-label={replie ? 'Afficher les infos pratiques' : 'Masquer les infos pratiques'}
          className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
          style={{ background: 'rgba(247,240,234,0.12)', color: CREME_DOUX }}
        >
          {replie ? '⌄' : '⌃'}
        </button>
      </div>

      {!replie && (
        <div className="relative mt-2.5 pt-2.5" style={{ borderTop: '1px solid rgba(247,240,234,0.16)' }}>
          {marche.lieu && (
            <p className="text-[12px] flex items-start gap-1.5" style={{ color: CREME_DOUX }}>
              <span className="flex-shrink-0">📍</span>
              <span>{marche.lieu}</span>
            </p>
          )}
          {(nbStands > 0 || nbProduits > 0) && (
            <p className="text-[12px] mt-0.5 flex items-center gap-1.5" style={{ color: CREME_DOUX }}>
              <span>🧑🏾‍🌾</span>
              <span>
                {nbStands} producteur{nbStands > 1 ? 's' : ''} · {nbProduits} produit{nbProduits > 1 ? 's' : ''} de saison
              </span>
            </p>
          )}
          {marche.lieu && (
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(marche.lieu)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2.5 px-4 py-2 rounded-full text-[12px] font-extrabold"
              style={{ background: ORANGE, color: VERT }}
            >
              📍 Itinéraire
            </a>
          )}
        </div>
      )}
    </div>
  )
}
